import { dataPencilSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPencilSolid = /*#__PURE__*/createIcon(dataPencilSolid)
export default IconPencilSolid
